import script from "./RenContract.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenContract.vue?vue&type=script&setup=true&lang=ts"

import "./RenContract.vue?vue&type=style&index=0&id=40f2c6b5&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f2c6b5"]])

export default __exports__